import { openWorkspaceDb } from '@/offline/db'
import { atomicLocalWrite, buildOperation } from '@/offline/queue'
import { pushOutbox, type PushSummary } from '@/offline/sync'
import { supabaseTransport } from '@/offline/transport'
import type { BuiltContact } from './contactPayload'

export async function saveContact(workspaceId: string, built: BuiltContact): Promise<PushSummary> {
  const db = openWorkspaceDb(workspaceId)
  const op = buildOperation({
    workspace_id: workspaceId,
    entity_id: built.contact.id,
    entity_type: 'contact',
    expected_revision: null,
    action: 'contact.create',
    payload: built.payload,
  })
  await atomicLocalWrite(db, [db.contacts], async () => {
    await db.contacts.add(built.contact)
  }, op)
  return pushOutbox(db, supabaseTransport())
}
